/**
 * Turn API / FastAPI error bodies into ordinary text.
 * `detail` may be a string, an object, or an array of { loc, msg }.
 * Never return "[object Object]".
 */

export function formatApiErrorDetail(detail) {
  if (detail == null || detail === '') return '';
  if (typeof detail === 'string') {
    const trimmed = detail.trim();
    return trimmed === '[object Object]' ? '' : trimmed;
  }
  if (typeof detail === 'number' || typeof detail === 'boolean') {
    return String(detail);
  }
  if (Array.isArray(detail)) {
    return detail.map(formatApiErrorDetail).filter(Boolean).join(' ').trim();
  }
  if (typeof detail === 'object') {
    if (typeof detail.msg === 'string' && detail.msg.trim()) {
      const locParts = Array.isArray(detail.loc)
        ? detail.loc.filter((part) => part !== 'body' && (typeof part === 'string' || typeof part === 'number'))
        : [];
      const loc = locParts.join(' ');
      const msg = detail.msg.trim();
      return loc ? `${loc}: ${msg}` : msg;
    }
    if (typeof detail.message === 'string' && detail.message.trim()) {
      return detail.message.trim();
    }
    if (detail.detail != null && detail.detail !== detail) {
      return formatApiErrorDetail(detail.detail);
    }
    return '';
  }
  return '';
}
